import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import {
  AuthPasskeyChallengeLoginRequestBody,
  AuthPasskeyChallengeLoginResponse,
} from "./types";

export class AuthPasskeyChallengeLoginAPI extends BaseAPI<
  AuthPasskeyChallengeLoginRequestBody,
  AuthPasskeyChallengeLoginResponse
> {
  protected route = ApiRoutes.auth.passkey_challenge_login;
  protected method = RequestMethod.POST;
  protected displayError = false;
}
